import * as React from 'react';
import { createContext, useState } from 'react';
import { CategoryDictionary, FrostDates, Plant, PlantingLocation } from './Types';
import { plants } from './Plants';

type FrostDateCtx = {
    frostDates: null | FrostDates;
    setFrostDates: React.Dispatch<React.SetStateAction<null | FrostDates>>;
};
type PlantingLocationCxt = {
    plantingLocation: null | PlantingLocation;
    setPlantingLocation: React.Dispatch<React.SetStateAction<null | PlantingLocation>>;
};
type PlantsCtx = {
    plants: Plant[];
    plantCategories: string[];
    categoryDictionary: CategoryDictionary;
};

const FrostDatesContext = createContext<FrostDateCtx>({ frostDates: null, setFrostDates: () => { } });
const PlantingLocationContext = createContext<PlantingLocationCxt>({ plantingLocation: null, setPlantingLocation: () => { } });

// let inIframe = false;
// try {
//     inIframe = window.frameElement ? true : false;
// } catch (_) { inIframe = true; }
// console.log('inIframe:', inIframe);
// const queryParams = new URLSearchParams(window.location.search);
// const frameState = {
//     storeFront: queryParams.get('storeFront'),
//     bannerImage: decodeURI(queryParams.get('bannerImage') ?? ''),
//     inIframe,
//     parentOrigin: '',
//     plannerLoaded: false,
//     eventListenerAdded: false,
//     initialZipCode: queryParams.get('zipCode') ?? '',
//     onChange: () => { }
// };
// if (frameState.storeFront === 'sgs') {
//     frameState.parentOrigin = 'https://survivalgardenseeds.com';
// }
// const filteredPlants = plants.filter(p => {
//     if (frameState.storeFront === 'sgs') return p.availableSgs;
//     if (frameState.storeFront === 'sowright') return p.availableSowright;
//     return true;
// }) as unknown as Plant[];
// const plantCateogries = new Set<string>();
// filteredPlants.forEach(({ type }) => plantCateogries.add(type));
//@ts-ignore
const plannerConfig: PlannerConfig | undefined = window.plantingPlannerConfig;
const typedPlants = plants as unknown as Plant[];
const getFilteredPlantList = (): Plant[] => {
    if (!plannerConfig) return typedPlants;
    if (plannerConfig.storeFront === 'sgs') return typedPlants.filter(p => p.availableSgs);
    if (plannerConfig.storeFront === 'sowright') return typedPlants.filter(p => p.availableSowright);
    return plants as unknown as Plant[];
}
const filteredPlants = getFilteredPlantList();
const plantCateogries = new Set<string>();
filteredPlants.forEach(({ type }) => plantCateogries.add(type));
const plantCategories = Array.from(plantCateogries);
var categoryDictionary = {} as CategoryDictionary;
filteredPlants.forEach(row => {
    const r = row as unknown as Plant;
    if (!categoryDictionary[row.type]) {
        categoryDictionary[row.type] = [r];
    } else {
        categoryDictionary[row.type].push(r);
    }
});

export const getPlannerConfig = () => plannerConfig ?? null;
const PlantsContext = createContext<PlantsCtx>({
    plants: filteredPlants,
    plantCategories,
    categoryDictionary});
// for (const [key, value] of queryParams) {
//     console.log(key, value);
// };

// function getInitialFrameState() {
//     let inIframe = false;
//     try {
//         inIframe = window.frameElement ? true : false;
//     } catch (_) { inIframe = true; }
//     console.log('inIframe:', inIframe);
//     const queryParams = new URLSearchParams(window.location.search);
//     const frameState = {
//         storeFront: queryParams.get('storeFront'),
//         bannerImage: decodeURI(queryParams.get('bannerImage') ?? ''),
//         inIframe,
//         parentOrigin: '',
//         plannerLoaded: false,
//         eventListenerAdded: false,
//         initialZipCode: queryParams.get('zipCode') ?? '',
//         onChange: () => { }
//     };
//     if (frameState.storeFront === 'sgs') {
//         frameState.parentOrigin = 'https://survivalgardenseeds.com';
//     } else if (frameState.storeFront === 'sowright') {
//         frameState.parentOrigin = 'https://sowrightseeds.com';
//     }
//     const filteredPlants = plants.filter(p => {
//         if (frameState.storeFront === 'sgs') return p.availableSgs;
//         if (frameState.storeFront === 'sowright') return p.availableSowright;
//         return true;
//     }) as unknown as Plant[];
//     const plantCateogries = new Set<string>();
//     filteredPlants.forEach(({ type }) => plantCateogries.add(type));

//     const plantCategories = Array.from(plantCateogries);
//     var categoryDictionary = {} as CategoryDictionary;
//     filteredPlants.forEach(row => {
//         const r = row as unknown as Plant;
//         if (!categoryDictionary[row.type]) {
//             categoryDictionary[row.type] = [r];
//         } else {
//             categoryDictionary[row.type].push(r);
//         }
//     });
//     return frameState;
// }
// type FrameState = ReturnType<typeof getInitialFrameState>;
type ConfigCtx = {
    config: PlannerConfig | null;
};


type PlannerConfig = {
    storeFront: string,
    bannerImage: string,
    primaryColor: string,
    primaryColorContrastText: string,
    font: {
        family: string,
        style: string,
        weight: number,
        faillback: string,
        ratio: number
    }
    dev: boolean,
    hosted: boolean
};

export const plannerUrls = {
    api: () => {
        const plannerConfig = getPlannerConfig();
        console.log(plannerConfig === null ? 'No planner config found' : plannerConfig);
        if (!plannerConfig) return '';
        if (!plannerConfig.hosted) return '';
        return 'https://plantingplanner.azurewebsites.net';
    },
    bannerImage: () => getPlannerConfig()?.bannerImage ?? '',
}
const ConfigContext = createContext<ConfigCtx>({ config: getPlannerConfig() });
console.log(encodeURIComponent('/cdn/shop/files/Web_Banner_Header_1800_x_600_px_1600x.png?v=1696279190'));
function AppCtxProvider({ children }: { children: React.ReactNode }) {
    const [config] = useState<PlannerConfig | null>(getPlannerConfig());
    const [frostDates, setFrostDates] = useState<null | FrostDates>(null);
    const [plantingLocation, setPlantingLocation] = useState<null | PlantingLocation>(null);
    return (
        <PlantingLocationContext.Provider value={{ plantingLocation, setPlantingLocation }}>
            <FrostDatesContext.Provider value={{ frostDates, setFrostDates }}>
                <PlantsContext.Provider value={{ plants: filteredPlants, plantCategories, categoryDictionary }}>
                    <ConfigContext.Provider value={{ config }}>
                        {children}
                    </ConfigContext.Provider>
                </PlantsContext.Provider>
            </FrostDatesContext.Provider>
        </PlantingLocationContext.Provider>);
}
export {
    FrostDatesContext,
    PlantingLocationContext,
    PlantsContext,
    AppCtxProvider,
    ConfigContext
}